import { z } from "zod";

export const conversionGetBaseSchema = z.object({
  event_type: z.string(),
  performed_behavior_window_in_seconds: z.int().min(0),
  unadjusted_behavior_window_in_seconds: z.int().optional(),
});
